var path = 'areas/projects/actions/azure_web_app/Octopus.MachineEvaluation_edit.html';
var html = "<control-group label=\"Script source\"> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Script.ScriptSource\"]' value=Inline> Full health check</label> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Script.ScriptSource\"]' value=Package> Only check connectivity</label> </control-group>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_web_app/Octopus.MachineEvaluation_edit.html
// module id = 1449706169591925
// module chunks = 1